import React, { useEffect, useState } from 'react';
import { NAV_LINKS, OFFER_ANCHOR, TICKER_ITEMS } from '../data/welding';

/** Slim moving ribbon + compact sticky header. */
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Four copies per half keep the loop seamless on wide screens.
  const half = [...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS];
  const track = [...half, ...half];
  return <>
      <div className="marquee overflow-hidden border-b border-arc/25 bg-surface" data-id="element-113" data-mp="29u7prmm73jh7">
        <p className="sr-only" data-id="element-114" data-mp="25x1t1lqq6ezv">{TICKER_ITEMS.join(' • ')}</p>
        <div className="animate-marquee flex w-max items-center py-[6px]" aria-hidden data-id="element-115" data-mp="3lao7jml82c78">
          {track.map((item, index) => <span key={`${item}-${index}`} className="flex shrink-0 items-center whitespace-nowrap font-heading text-[12px] font-semibold uppercase tracking-[0.18em] text-steel-pale" data-id="element-116" data-mp="3h9ukswjin3fx" data-mpi={index}>
              {item}
              <span className="mx-7 h-1 w-1 rotate-45 bg-orange sm:mx-9" data-id="element-117" data-mp="1kwffgi37xqys" />
            </span>)}
        </div>
      </div>

      <header className={`sticky top-0 z-30 border-b transition-colors duration-200 ease-out ${scrolled ? 'border-white/10 bg-charcoal/95 backdrop-blur' : 'border-transparent bg-charcoal'}`} data-id="element-118" data-mp="1puqpotxfe3hj">
        <div className="mx-auto flex h-14 w-full max-w-6xl items-center justify-between gap-4 px-5 sm:px-8" data-id="element-119" data-mp="x5a0e553r2pj">
          <a href="#top" className="flex min-h-[44px] items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-arc" aria-label="WELDING PROJECT PLANS™ — back to top" data-id="element-120" data-mp="124mikcl13lls">
            <span className="wordmark whitespace-nowrap text-[1.02rem] text-white sm:text-[1.15rem]" data-id="element-121" data-mp="egd1fnyrfm0z">
              Welding <span className="text-steel-pale" data-id="element-122" data-mp="1hqzdwg1n312c">Project Plans</span>
              <sup className="ml-0.5 font-sans text-[0.5em] font-semibold" data-id="element-123" data-mp="1cspeft8vteax">™</sup>
            </span>
          </a>

          <nav aria-label="Sections" className="hidden items-center gap-7 lg:flex" data-id="element-124" data-mp="1qkm47qn2vc45">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-[0.88rem] font-medium text-steel-light transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:text-arc-light" data-id="element-125" data-mp="1mjk5dax2p22p">
                {link.label}
              </a>)}
          </nav>

          <a href={OFFER_ANCHOR} className="hidden min-h-[44px] items-center rounded-[8px] border border-orange/70 px-4 font-heading text-[0.95rem] font-bold uppercase tracking-[0.06em] text-orange transition-colors duration-150 ease-out hover:bg-orange hover:text-charcoal focus:outline-none focus-visible:ring-4 focus-visible:ring-arc/60 sm:inline-flex" data-id="element-126" data-mp="12uhzffy5l6bk">
            Get the Collection
          </a>
        </div>
      </header>
    </>;
}